import React, {  useState } from "react";
import Modal from "../Modal/Modal";
import { ButtonContainer } from "../Shared/ButtonComponent";

import LaundryUpload from "./LaundryUpload";

const LaundrySummary = ({
  setLaundrySummary,
  setLaundryDetails,
  laundryNewOrder,
  laundryTypData,
}) => {
  const [laundryUpload, setLaundryUpload] = useState(false);

  const laundryType = laundryNewOrder?.laundry?.laundry_type;

  return (
    <div className="col-12">
      <div className="col-12 side-menu ">
        {/* <div className="side-menu__overlay" /> */}
        <div className="side-menu__content laundry_sum">
          <div className="laundrySummary_header">
            <button
              onClick={() => setLaundrySummary(false)}
              className="backArrow"
            >
              <i className="fa-solid fa-arrow-left"></i>
              <span>Back</span>
            </button>
            <div>
              <p>Order Summary</p>
            </div>
          </div>
          <div className="laundrySummary-content">
            <div>
              <div>Services</div>
              <div>Rate</div>
              <div>Qty</div>
            </div>
            {laundryType?.map((item, index) => (
              <div key={index}>
                <div>
                  <div className="cloth_type ">{item.cloth_type}</div>
                  <div className="service_type">
                    ({item.service_type + " & " + item.extra})
                  </div>
                </div>
                <div>{item.price}</div>
                <div>{item.cloth_count}</div>
              </div>
            ))}
          </div>

          <div>
            <div className="col-12 laundrySummary-footer">
              <div>
                <span>Subtotal:</span>
                <span>₦{laundryNewOrder?.total_checkout_price}</span>
              </div>
              <div>
                <span>Delivery Price:</span>
                <span>₦{laundryNewOrder?.delivery_price}</span>
              </div>
              <div>
                <span>Total:</span>
                <span>₦{laundryNewOrder?.total_checkout_price + laundryNewOrder?.delivery_price}</span>
              </div>
            </div>
            <div className="laundry-footer laundry_summary">
              <div>
                <ButtonContainer onClick={() => setLaundryUpload(true)}>
                  Next
                </ButtonContainer>
              </div>
              <div>
                <ButtonContainer cart>Cancel</ButtonContainer>
              </div>
            </div>
          </div>
        </div>
      </div>

      {laundryUpload && (
        <Modal>
          {" "}
          <LaundryUpload
            {...{
              setLaundryUpload,
              setLaundryDetails,
              setLaundrySummary,
              laundryNewOrder,
            }}
          />
        </Modal>
      )}
    </div>
  );
};

export default LaundrySummary;
